import React from 'react'
import { get } from 'lodash'
import axios from 'axios'
import getCountryCode from '~/tools/userEnvironment/getCountryCode'
import { addUserProfile, trackEvent } from '~/tools/analytics/cleverTap'
import userStore from '~/redux/user/store'
import { getToken } from '~/redux/user/tokens'
import { signup } from '~/redux/user/actions'
import Cookies from 'js-cookie'
import {getActivePaymentMethod} from '~/services/userService';
import getQueryVariable from '~/tools/getQueryVariable';
import { format } from "date-fns";
import getPriceFormat from "~/tools/getPriceFormat"

import popup from '../../../popup'
import './style.scss'
import {PHONE_FROM_COUNTRY} from '../../../countryConstants'


class CreateLogin extends React.Component {
  constructor(props) {
    super(props)
    this.state = { 
      selected: null, 
      signupCheckbox: true, 
      signupFormValid: false,
      emailConsent: {},
      emailChecked: null,
      form: null
    }
    this.toggleEmailCheck = this.toggleEmailCheck.bind(this)
    this.isOTPEnabled = get(window.settings, 'features.otp_value.otp_enabled');
    this.isEmailRequiredWithOTP = get(window.settings, 'features.otp_value.email_required');
  }

  getVal(key){
    return get(this.props.metadataMap, key)
 }  

  toggleEmailCheck(e) {
    this.setState({
      emailChecked: e.target.checked
    })
  }

  fetchEmailConsent() {
    let emailConsentUrl = `https://d2tipiv4cs5bo1.cloudfront.net/emailconsent/${window.settings.internalName}.json`
    return axios.get(emailConsentUrl).then( r => {
      let emailConsentConfig = r.data
      
      return getCountryCode().then( countryCode => {
        let config = emailConsentConfig[countryCode] || emailConsentConfig.default || {}
        this.setState({
          emailConsent: config, 
          emailChecked: config.checked
        }) 
      })
    }).catch( e => {
      return 
    })
  }

  renderEmailConsent() {
    const { emailConsent, emailChecked } = this.state
    if (!emailConsent.visible)
      return 
    
    return (
      <div className="email-consent">
        <input onChange={this.toggleEmailCheck} type="checkbox" checked={emailChecked}/>
        <div className="copy" dangerouslySetInnerHTML={{__html: emailConsent.copy}}></div>
      </div>
    )
  }

  componentDidMount(){
    this.fetchEmailConsent()
    getCountryCode().then( countryCode => {
      if(this.phoneInputCode)
        this.phoneInputCode.value="+"+PHONE_FROM_COUNTRY[`${countryCode}`]
    })
    window.sessionStorage.getItem('offer') && this.checkOfferValidity()
    getActivePaymentMethod(this.props.paymentHandler).then((m) => {
      this.setState({
        form: m
      })
    })
  }

  shouldDisableLogin() {
    if (!this.state.signupFormValid)
      return true
      
    return false
    // if (!this.state.emailConsent.visible)
    //   return false

    // return !this.state.emailChecked
  }

  render() {
    return (
      <div className="signup">
        { this.selectedPlanT() }
        { this.props.user ? this.continueAsUserT() : this.signupFormT() }
      </div>
    )
  }

  selectedPlanT() {
    var { plan, editPlan } = this.props
    const pd = (plan && plan.planDetails && plan.planDetails[0]) || {}
    if (!plan) return
    var phoneNumber = (window.settings.customerService || {}).phone
    var formattedPhoneNumber = phoneNumber && phoneNumber.replace(/(\d{1})(\d{3})(\d{3})(\d{4})/, "$1-$2-$3-$4")
    let planDetails = pd.description || plan.description
    let expiration = this.props.firstPayment && format(this.props.firstPayment.nextBillingDate, "MM/DD/YYYY") || ''
    let priceFormat = pd && getPriceFormat(pd, plan) || 'N/A'
    planDetails= planDetails && planDetails.replace(/\[deadline\]/g, expiration)
    planDetails= planDetails && planDetails.replace(/\[price\]/g, priceFormat)
    const paymentHandler = getQueryVariable('paymentMethod') || this.state.form;

    return (
      <div className="selected-plan">
        <div className="title">
          { pd.title || plan.name }
          { editPlan &&<span className="link-button site-color site-border-color edit-plan" onClick={ _ => this.props.editPlan() }>
            {this.getVal('editPlan')}
          </span> }   
        </div>
        <div className="desc">{ editPlan ? ((pd.title || plan.name) +' '+ this.getVal('planDetail')) : '' }</div>
        <div className="details"> <div dangerouslySetInnerHTML={{__html: planDetails}} /> </div>
        <div className="bottom">
          {/* { paymentHandler !== 'paygate' && this.offerCodeEl() } */}
          { this.offerCodeEl() }
          <div className="company">
            { window.settings.companyName } {formattedPhoneNumber && `|${ formattedPhoneNumber }`}
          </div>
        </div>
      </div>
    )
  }

  offerCodeEl() {
    return (
      <div className="code">
        { this.props.offerCode ? (
          <div>
            {this.getVal("billingOfferAppliedLeft")} {this.getVal("billingOfferAppliedRight")} - { this.props.offerCode.displayName || this.props.offerCode.name }<br />
            <span
              className="remove-code-button link-button site-color site-border-color"
              onClick={ _ => this.props.removeCode() }> {this.getVal('removePromo')} </span>
          </div>
        ) : !this.props.editingOfferCode ? ( <div>
          {this.getVal('promoHeading')}
          <span
            className="add-code-button link-button site-color site-border-color"
            onClick={ _ => this.props.editOfferCode(true) }>{this.getVal('addPromo')}</span>
        </div> ) : ( <div>
          <input
            autoFocus
            className="offer-code-input"
            onKeyPress={ e => { if (e.key === 'Enter') this.onClickApply() } }
            ref={ el => this.codeInput = el } />&nbsp;
          <span
            className={'apply link-button site-color site-border-color' + (this.state.postingValidate ? ' processing': '')}
            onClick={ e => this.onClickApply(e) }
            >{this.getVal('applyPromo')}</span>
          &nbsp;
          <span className="remove-code-button link-button site-color site-border-color" onClick={ _ => this.props.editOfferCode(false) }> {this.getVal('cancelPromo')} </span>
        </div> ) }
        <div className="error">{ this.state.offerCodeError } </div>
      </div>
    )
  }

  checkOfferValidity(){
    this.props.editOfferCode(true)
    this.onClickApply()
  }

  onClickApply(e) {
    var offerCode = (this.codeInput && this.codeInput.value.toUpperCase()) || window.sessionStorage.getItem('offer').toUpperCase()

    this.setState({ postingValidate: true })
    return getToken().then(token => {
      return axios({
        method: "POST",
        url: `${window.settings.apiBaseUrl}/subscription/offer/validate`,
        params: { site: window.settings.internalName },
        data: {
          offerCode: offerCode,
          subscriptionPlanId: this.props.plan.id,
          site: window.settings.internalName
        },
        headers: {
          Authorization: token,
          "x-api-key": window.settings.baseAPIKey
        }
      });
    })
    .then( (res, data) => {
      this.props.addCode({
        displayName: res.data.displayName,
        name: res.data.name,
        code: offerCode
      })
    }).catch(err => {
      var message = (((err || {}).response || {}).data || {}).code
      this.setState({...this.state,
        offerCodeError: (this.getVal(message) || this.getVal('promoValidatingError'))
      })
      setTimeout(_ => this.setState({...this.state, offerCodeError: null }), 2000)
    }).then( _ => {
      this.setState({ postingValidate: false })
    })
  }

  continueAsUserT() {
    return (
      <div className="continue">
        <div className="title">{this.getVal('createdAccountHeading')}</div>
        <div className="desc">{this.getVal('createdAccountdesc')}</div>
        <div className="userInfo">
          <div className="head"> {this.getVal('userInfoHeading')} </div>
          <div className="name"> { this.props.user.name }</div>
          <div className="email">{ this.props.user.email } </div>
        </div>
        {!this.props.user && <div className="terms">
          <div  dangerouslySetInnerHTML={{ __html: this.getVal('createAccountAgreement')}}/>
        </div>}
        <div className="continue-button button cta" onClick={ _ => this.props.continue() }>
          {this.getVal('continueCtaText')}
        </div>
      </div>
    )
  }

  signupFormT() {
    let shouldDisableLogin = this.shouldDisableLogin()
    if(this.isOTPEnabled){
      shouldDisableLogin=false;
    }
    return (
      <form className="signup-form" onSubmit={ e => this.signup(e) }>
        <div className="title">{this.getVal('createAccountHeading')}</div>
        <div className="desc">{this.getVal('createAccountdesc')}</div>
        <div className="inputs">


        {(!this.isOTPEnabled || (this.isOTPEnabled && this.isEmailRequiredWithOTP)) && <input
            type="email"
            placeholder={this.getVal('createAccountEmail')}
            ref={ el => { this.emailInput = el } }
            onKeyUp={ e => this.onInputChange(e) }
            onFocus={ e => this.onInputChange(e) } required/>}

        {this.isOTPEnabled && 
              <div className="phone-input-subscription-box">
                <input 
                    placeholder="+91"
                    ref={ i => { this.phoneInputCode = i} }  
                    autoFocus  
                    className="phone-subscription"
                    required
                  />

                  <input  
                    type="number"
                    placeholder={this.getVal('phoneInput') || "Please Enter Phone Number"}
                    ref={ i => { this.phoneInputNumber = i} } 
                    className="phone-subscription" 
                    autoFocus 
                    required         
                  />
          </div>}

         
          {!this.isOTPEnabled && <input
            type="text"
            placeholder={this.getVal('createAccountName')}
            ref={ el => { this.nameInput = el } }
            onKeyUp={ e => this.onInputChange(e) }
            onFocus={ e => this.onInputChange(e) } required/>}
        

          {!this.isOTPEnabled && <div className="password-input">
            <input
              type={ this.state.showPassword ? 'text' : 'password' }
              placeholder={this.getVal('createAccountPassword')}
              ref={ el => { this.passwordInput = el } }
              onKeyUp={ e => this.onInputChange(e) }
              onFocus={ e => this.onInputChange(e) } required/>

            <span
              className="show-password-button"
              onClick={ e => { this.setState({...this.state, showPassword: !this.state.showPassword }) } }>
              <i className="ion-eye"></i>
            </span>
          </div>}
        </div>
        {/*<div
          className="signup-checkbox site-color"
          onClick={ e => { this.setState({...this.state, signupCheckbox: !this.state.signupCheckbox }) } }>
          { this.state.signupCheckbox  && (<i className="ion-checkmark"> </i>) }
        </div>
        <div className="signup-text">
          Keep me informed about future updates. You can unsubscribe anytime.
        </div>*/}
        
        <div className="terms-text">
          <div className="displayFlex">
            {this.props.moduleSettings && this.props.moduleSettings.privacyCheck && <div>
              <input 
                name="privacyCheck"
                type="checkbox" 
                id="privacyCheck" 
                onClick={() => this.setState({
                  isPrivacyChecked:!this.state.isPrivacyChecked, 
                  privacyCheckError:null
                })}                  
              />  
            </div>}
            <div  dangerouslySetInnerHTML={{ __html: this.getVal('createAccountAgreement')}}/>
          </div>
          { this.state.privacyCheckError && !this.state.isPrivacyChecked && 
          <div className="ageCheckError">{this.state.privacyCheckError}</div> 
          }
        </div>
        
        { this.renderEmailConsent() }
        { window.settings.features.legal_verbiage &&
            <div className="ageCheck terms-text">
              { this.state.ageCheckError && !this.state.ageIsChecked && 
                <div className="ageCheckError">{this.state.ageCheckError}</div> 
              }
              <input 
                name="ageCheck"
                type="checkbox" 
                id="ageCheck" 
                onClick={() => this.setState({
                  ageIsChecked:!this.state.ageIsChecked, 
                  ageCheckError:null
                })}                  
              />
              <label htmlFor="ageCheck">{window.settings.features.legal_verbiage_copy}</label>
            </div>
          }
        <input
          className={
            'button ' +
            (shouldDisableLogin ? ' inactive' : 'site-background-color') +
            (this.state.signupProcessing ? ' processing' : '')
          }
          type="submit"
          value={window.settings.serviceType === 'SVOD'? this.getVal('createAccountSubscribe') : this.getVal('createAccountSignUp')} />

        <div className={ 'error-text site-color' + (this.state.signupAlertText ? ' shown' : '')  }>
          { this.state.signupAlertText }
        </div>

        <div className="already-account">
          {this.getVal('createdAccountAlready')}
          &nbsp;
          <span 
            className="link-button site-color site-border-color" 
            onClick={ _ => this.props.goToLogin() }
          >{this.getVal('signInCta')}</span>
        </div>
      </form>
    )
  }

  onInputChange(e) {
    const errorTextBox = document.getElementsByClassName('error-text')
    const atPassword = e.currentTarget.type.indexOf('password') !== -1

    let password = this.passwordInput && this.passwordInput.value;
    if(password && password.length > 0) {
      errorTextBox[0].classList.add('shown')
      if(password.length < 5 || password.length > 50){
        errorTextBox[0].textContent = 'Password should be between 5 and 50 characters'
        this.setState({...this.state, signupFormValid: false})
        return false;
      }
      errorTextBox[0].textContent= ''
      errorTextBox[0].classList.remove('shown')
    }

    if(this.isOTPEnabled){
      this.setState({...this.state, signupFormValid: this.emailInput.value && this.phoneInputCode.value && this.phoneInputNumber.value});
    }else{
      this.setState({...this.state, signupFormValid: this.nameInput.value && this.emailInput.value && this.passwordInput.value});
      if(!atPassword) {
        errorTextBox[0].classList.remove('shown')
      }
    }
  }

  enableButton(){
    var signupFormValid = this.nameInput.value && this.emailInput.value && this.passwordValid
    if (signupFormValid !== this.state.signupFormValid)
      this.setState({...this.state, signupFormValid: signupFormValid})
  }

   signup= async(e)=>{
    e.preventDefault();
    const element = document.getElementById('ageCheck')
    const privacyCheckEle = document.getElementById('privacyCheck')
    if(element){
      const ageCheck = element.checked
      if (!ageCheck){
        this.setState({ageCheckError:window.settings.features.legal_verbiage_error})
        return
      }
    }

    if(privacyCheckEle){
      const privacyCheck = privacyCheckEle.checked
      if (!privacyCheck){
        this.setState({privacyCheckError:this.getVal('acceptLoginTermError') || 'Please accept privacy policy.'})
        return
      }
    }

    this.setState({ signupProcessing: true, signupAlertText: '' })

    var user = {
      name: this.nameInput && this.nameInput.value,
      email: this.emailInput &&  this.emailInput.value,
      password: this.passwordInput && this.passwordInput.value,
      emailConsent: this.state.emailConsent.visible ? this.state.emailChecked : undefined
    }

    var metaMap=this.props["metadataMap"];

    if(this.isOTPEnabled){
      user={};
      user["requestType"]="send";
      user["phoneNumber"]=this.phoneInputCode.value+this.phoneInputNumber.value
      if(this.emailInput){
        user["email"]= this.emailInput.value;
      }

      var signupParams = {
        site: window.settings.internalName
      }
      await axios({
        method: 'POST',
        url: `${window.settings.apiBaseUrl}/identity/signup`,
        params: signupParams,
        data: user,
        headers: {
          'x-api-key': window.settings.baseAPIKey
        }
      }).then( res => {
        user["screenName"]="subscription"
        user["planId"]= this.props.plan && this.props.plan.id;
        popup.verifyOTPScreen(user, metaMap);
        this.setState({ signupProcessing: false })
      }).catch(error=>{
        this.setState({ signupProcessing: false })
        var message =
          this.getVal((((error || {}).response || {}).data || {}).code) || this.getVal('defaultError')
        this.signupAlert(message)
      })
    }else{
      userStore
      .dispatch(signup(user))
      .then( _ => {
        this.setState({ signupProcessing: false })
          //Signup Personalization
          Cookies.set('isUserSignUp', true);
          var userInfo = this.props.user
          addUserProfile('Site', {
            'Name': userInfo.name,
            'Email': userInfo.email,
            'Identity': userInfo.userId,
            'User Status': userInfo.isSubscribed ? 'Subscribed' : 'Registered and Never Subscribed',
          })
          trackEvent('Signed Up', {registrationType: 'Native',platform:'Web'})
          setTimeout(_ => this.props.continue(), 200)
        
      })
      .catch(error => {
        this.setState({ signupProcessing: false })
        var message =
          this.getVal((((error || {}).response || {}).data || {}).code) || this.getVal('defaultError')
        this.signupAlert(message)
      })
    }
  }

  signupAlert(txt) {
    this.setState({...this.state, 'signupAlert': true, signupAlertText: txt })
  }
}

export default CreateLogin;
